import React from "react";
import { FaCode, FaToggleOn, FaToggleOff } from "react-icons/fa";

export default function AddMCQTopic({ formData, setFormData, errors }) {
  const handleMCQQuestionChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      mcq: { ...prev.mcq, question: value },
    }));
  };

  const handleMCQOptionChange = (index, value) => {
    const newOptions = [...formData.mcq.options];
    newOptions[index] = value;
    setFormData((prev) => ({
      ...prev,
      mcq: { ...prev.mcq, options: newOptions },
    }));
  };

  const handleMCQCorrectOptionChange = (index) => {
    setFormData((prev) => ({
      ...prev,
      mcq: { ...prev.mcq, correctOption: index },
    }));
  };

  const handleCodeToggle = () => {
    setFormData((prev) => ({
      ...prev,
      mcq: { 
        ...prev.mcq, 
        hasCode: !prev.mcq.hasCode,
        code: !prev.mcq.hasCode ? prev.mcq.code || "" : ""
      },
    }));
  };

  const handleCodeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      mcq: { ...prev.mcq, code: value },
    }));
  };

  return (
    <div className="space-y-6 border-t pt-8">
      <h3 className="text-lg font-semibold text-gray-900">MCQ Topic</h3>
      <div className="p-6 border border-gray-200 rounded-lg space-y-4">
        <label className="block text-sm font-semibold text-gray-700">
          Question *
        </label>
        <textarea
          value={formData.mcq.question}
          onChange={(e) => handleMCQQuestionChange(e.target.value)}
          placeholder="Enter question text..."
          rows="2"
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        {/* Code Block Toggle */}
        <div className="border-t pt-4 mt-4">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <FaCode className="text-gray-600" />
              <span className="text-sm font-semibold text-gray-700">Add Code Block</span>
            </div>
            <button
              type="button"
              onClick={handleCodeToggle}
              className="flex items-center gap-2 text-sm"
            >
              {formData.mcq.hasCode ? (
                <FaToggleOn className="text-blue-600 text-2xl" />
              ) : (
                <FaToggleOff className="text-gray-400 text-2xl" />
              )}
            </button>
          </div>
          
          {formData.mcq.hasCode && (
            <div className="mt-3">
              <label className="block text-xs font-medium text-gray-600 mb-2">
                Go Code (will be wrapped in go: ... :go format)
              </label>
              <textarea
                value={formData.mcq.code || ""}
                onChange={(e) => handleCodeChange(e.target.value)}
                placeholder="arr := [3]int{1, 2, 3}&#10;s := arr[:2]&#10;fmt.Println(s)"
                rows="6"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono text-sm bg-gray-900 text-green-400"
              />
              <p className="text-xs text-gray-500 mt-1">
                Enter raw Go code. It will be displayed in a styled code block below the question.
              </p>
            </div>
          )}
        </div>

        <div className="space-y-3">
          <label className="text-sm font-semibold text-gray-700">Options</label>
          {formData.mcq.options.map((opt, oIndex) => (
            <div key={oIndex} className="flex items-center gap-3">
              <input
                type="radio"
                name="correctOption"
                checked={formData.mcq.correctOption === oIndex}
                onChange={() => handleMCQCorrectOptionChange(oIndex)}
                className="w-4 h-4 text-blue-600"
              />
              <input
                type="text"
                value={opt}
                onChange={(e) => handleMCQOptionChange(oIndex, e.target.value)}
                placeholder={`Option ${oIndex + 1}`}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          ))}
        </div>
        {errors.mcq && <p className="text-red-600 text-sm mt-1">{errors.mcq}</p>}
      </div>
    </div>
  );
}
